
import SBPBoundingBox from './SBPBoundingBox';

export default class SBPBoardBoundingBox extends SBPBoundingBox {
  constructor (bin) {
    let min = new THREE.Vector3(bin.xoffset, bin.yoffset, 0);
    let max = new THREE.Vector3(bin.width + bin.xoffset, bin.depth + bin.yoffset, bin.thickness);
    super(min, max, new THREE.Color(0x707070), '#000000');
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/sbp/SBPBoardBoundingBox.js